import React from "react";
import { Component } from "react";
import MovieSearchArea from "./MovieSearchArea";
import MovieList from "./MovieList";
import MovieDetails from "./MovieDetails";
import request from 'superagent';


class MovieArea extends Component {
    constructor(props) {
        super(props);
        this.state = {
            movies: [],
            searchField: '',
            apiKey: "aed346e7e561872b9429ec2a49a62170",
            sort: '',
            favorites: [],
            currentMovie: null
        }
    }


    addMovieToWatchlist = (movie) => {
        const newFavoriteList = [this.state.favorites, movie]
        this.setState({favorites: newFavoriteList}) 
        console.log("Added to favorites!");
    }

    viewMovieDetails = (id) => {
        const filteredMovie = this.state.movies.filter(movie => movie.id === id);

        const newCurrentMovie = filteredMovie.length > 0 ? filteredMovie[0] : null;
        this.setState({currentMovie: newCurrentMovie});
    }

    closeMovieDetails = () => {
        this.setState({currentMovie: null})
    }

    searchMovie = (e) => {
        e.preventDefault();
        console.log(this.state.searchField);
        if (this.state.searchField !== "") {
            request
            .get("https://api.themoviedb.org/3/search/movie?api_key="+ this.state.apiKey + "&language=en-US&page=1&include_adult=false&query=" + this.state.searchField)
            .then((data) => {
                console.log(data);
                const cleanData = this.cleanData(data)
                this.setState({ movies: cleanData})
            })
        }
    }

    //update state met wat er in het searchfield staat
    handleSearch = (e) => {
        console.log(e.target.value);
        this.setState({ searchField: e.target.value})
    }


    //clean data: voor als een book geen prop heeft en default value geven
    cleanData = (data) => {
        const cleanedData = data.body.results.map((movie) =>{
            if(movie.hasOwnProperty('poster_path') === false){
                movie['poster_path'] = {thumbnail: 'https://upload.wikimedia.org/wikipedia/commons/a/ac/No_image_available.svg'}
            }

            return movie;
        })

        return cleanedData;
    }



    render(){
        return (
            <div>
                <h1 className="pageTitle">Search movies</h1>
                { this.state.currentMovie === null ? 
                            <div>
                                <MovieSearchArea searchMovie={this.searchMovie} handleSearch={this.handleSearch} handleSort={this.handleSort} />
                                <MovieList movies={this.state.movies} viewMovieDetails={this.viewMovieDetails}/>
                            </div> : <MovieDetails currentMovie={this.state.currentMovie} closeMovieDetails={this.closeMovieDetails} handleFavoritesClick={this.addMovieToWatchlist} />
                }
            </div>
        );
    }
}


export default MovieArea;

